import { useQuery } from 'react-query';
import { service } from '../redux/api/axios';
import { Topic } from '../redux/types/topics';
import HookTypes from '../redux/types/hooks';

const useHook = (id: string) => {
  return useQuery<Topic>([HookTypes.topic, id], async () => {
    if (!id || !id.length) return null;
    const response = await service.get(`/topics/${id}`);
    return response.data;
  });
};

export default useHook;
